export const isNotTabKey = (e: KeyboardEvent) => !e.keyCode || (e.keyCode !== 9 && e.keyCode !== 16 && e.keyCode !== 27);

export const isTabKey = (e: KeyboardEvent) => e.keyCode && e.keyCode === 9;

export const preventNegative = (e: KeyboardEvent) => {
  if (!/[0-9.]+/.test(e.key)) {
    e.preventDefault();
  }
};
